import { TopLoveSection } from './TopLoveSection'
import { withTopLoveSection } from './withTopLoveSection'

const ConnectedTopLoveSection = withTopLoveSection(TopLoveSection)
export { ConnectedTopLoveSection as TopLoveSection }
